import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { notify } from 'react-notify-toast';

import { DialogModalWindow, Input, Button } from 'src/components/shared'
import { models } from '../Factor'
import { createQuestions } from 'src/actions/prioritize'
import collectionApi from 'src/api/v2/CollectionApi'


const SAVE_PRESET_MODAL_TITLE = 'Save as New Template'
const ERROR_NOTIFICATION = 'Couldn\'t save a preset'
const SUCCESS_NOTIFICATION = 'Preset saved successfully'

const NewPreset = ({
  prioritize,
  factorsSource,
  createQuestions,
  setCurrentPreset,
  createQuestionsError,
  createQuestionsSuccess
}: {
  prioritize: {
    templateFactors: models.FactorInterface[],
    currentFactors: models.FactorInterface[]
  },
  createQuestions,
  setCurrentPreset: (payload: any) => {},
  factorsSource: 'current' | 'template'
  createQuestionsError: any,
  createQuestionsSuccess
}) => {
  const sourceProperty = factorsSource + 'Factors'
  const sourceFactors = prioritize[sourceProperty]

  const setRedux = useDispatch()
  const [isNewPresetModalOpen, setIsNewPresetModalOpen] = useState(false)
  const [presetName, setPresetName] = useState('')

  const onCofirmNewPreset = async () => {
    setIsNewPresetModalOpen(false)

    const getLongestToken = (text) =>
      text.split(' ').reduce((prev, curr) => curr.length > prev.length ? curr : prev, '')

    const collection_sub_type = getLongestToken(presetName)
    const payload = {
      collection_sub_type,
      title: presetName,
      collection_type: 'prioritize-factors',
    }

    try {
      const newPresetCollection = await collectionApi.create(payload);
      createQuestions({ parentId: newPresetCollection.id, questions: sourceFactors, isPreset: true });

      const presets = await collectionApi.getAllByType('prioritize-factors');
      setRedux({ type: 'GET_PRESETS', payload: presets })
      setCurrentPreset(payload)

    } catch (error) {
      notify.show(ERROR_NOTIFICATION, 'error', 5000, "white");
      console.error(error);
    }
  }

  useEffect(() => {
    if (createQuestionsError) {
      notify.show(ERROR_NOTIFICATION, 'error', 5000, "white");
    }
  }, [createQuestionsError])

  useEffect(() => {
    if (createQuestionsSuccess) {
      notify.show(SUCCESS_NOTIFICATION, 'success', 5000, "white");
    }
  }, [createQuestionsSuccess])


  return (<>
    <Button flat className="btn btn-flat btn-secondary"
      onClick={() => setIsNewPresetModalOpen(true)}>
      {SAVE_PRESET_MODAL_TITLE}
    </Button>

    <DialogModalWindow
      isOpen={isNewPresetModalOpen}
      title={SAVE_PRESET_MODAL_TITLE}
      onCancel={() => setIsNewPresetModalOpen(false)}
      onConfirm={onCofirmNewPreset}
      confirmBtnText="Save"
    >
      {/* <p>{SAVE_PRESET_MODAL_TEXT}</p> */}
      <Input
        onChange={({ target }) => setPresetName(target.value)}
        value={presetName}
        placeholder="Template name"
      />
    </DialogModalWindow>
  </>
  )
}

const mapStateToProps = ({ prioritize }) => {
  return {
    prioritize,
    createQuestionsSuccess: prioritize.createQuestionsSuccess,
    createQuestionsError: prioritize.createQuestionsError,
  };
};

export default connect(mapStateToProps, {
  createQuestions,
})(NewPreset);
